module.exports = __webpack_public_path__ + "static/img/icon_remt_svc_step_03.6b88ac8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/custcntr/icon_remt_svc_step_03.svg
// module id = 47j5
// module chunks = 10